<template>
  <el-dialog custom-class="list-dialog" title="促销协议" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-input style="width:200px;"
                  placeholder="请输入名称"
                  prefix-icon="el-icon-search"
                  v-model="searchdata">
        </el-input>
        <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
        <el-button type="warning" v-on:click="add">添加子合同</el-button>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(140)"
      size="mini"
      stripe
      border
      style="width: 100%;"
    >
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="pname" :show-overflow-tooltip="true"
        label="合同名称"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="合同编号"
        align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="jhjgrq"
        label="签订日期"
        align="center"
        width="85"
      >
        <template slot-scope="scope">
          {{scope.row.htqd.substr(0,10)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="jhjgrq"
        label="截止日期"
        align="center"
        width="85"
          >
          <template slot-scope="scope">
            {{scope.row.jhjgrq.substr(0,10)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="htje"
        label="合同金额"
        align="right"
        header-align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{scope.row.htje|numeric(2)}}
        </template>
      </el-table-column>
      <el-table-column label="统计" align="center" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleTJ(scope.$index, scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            v-if="scope.row.casestatus==0">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <SaleContractEdit ref="DataContactEdit" @bindGrid="bindGrid"></SaleContractEdit>
    <SaleContractTJ ref="SaleContractTJ"></SaleContractTJ>
  </el-dialog>

</template>

<script>
  import SaleContractEdit from './SaleContractEdit';
  import SaleContractTJ from './SaleContractTJ';
  import {getListData, deleteData} from '@/api/order/salecontract';

  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        controlData: [],
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        parenterpserial:"",
        parentguid:"",
        customerserial:"",
        customername:""
      }
    },
    methods: {
      handleTJ(index,row){
        this.$refs.SaleContractTJ.initData(row);
      },
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid);
      },
      handleDelete(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: row.unitguid,erpserial:row.erpserial}).then(response => {
            this.bindGrid();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      bindGrid() {
        this.pagination.total =0
        this.tableData =[]
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          parenterpserial:this.parenterpserial,
          search: this.searchdata,
        }).then(response => {
          this.pagination.total = response.data.obj.total
          this.tableData = response.data.obj.rows
        }).catch((error) => {
        });
      },


      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show(this.parenterpserial,this.parentguid,this.customerserial,this.customername)
      },
      show(row){
        this.dialogFormVisible=true
        this.parenterpserial=row.erpserial
        this.parentguid=row.unitguid
        this.customername=row.customername
        this.customerserial=row.customerserial
        this.bindGrid()
      }
    },
    mounted() {
    },
    components: {
      SaleContractEdit,
      SaleContractTJ
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .distpicker-address-wrapper {
    display: inline-block;
    position: relative;
    top: 2px;
  }

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/salecontract/ChildContractList.vue